import { Component, html, LitElement, property } from '@rxdi/lit-html';

/**
 * @customElement svg-repo
 */
@Component({
  selector: 'svg-repo',
  template(this: SvgRepoComponent) {
    const src = `https://www.svgrepo.com/download/${this.src}.svg`;
    return html` <img part="image" src=${src} width=${this.width} height=${this.height} @load=${this.load} /> `;
  },
})
export class SvgRepoComponent extends LitElement {
  @property()
  src: string;

  @property()
  width = 30;

  @property()
  height = 30;

  load(detail: Event) {
    this.dispatchEvent(new CustomEvent('load', { detail }));
  }
}
